/* Native Shopify prices for vehicle results whose app feed uses shop currency. */
(function () {
  'use strict';
  var config = window.DHNativeCurrency;
  if (!config || config.currency === config.baseCurrency) return;
  var seen = new WeakSet();
  var queue = [];
  var active = 0;
  var requests = new Map();
  var selector = '.vehicle-lookup-strict-card';

  function productPrice(handle) {
    if (!requests.has(handle)) {
      requests.set(handle, new Promise(function (resolve, reject) {
        queue.push({ handle: handle, resolve: resolve, reject: reject });
        pump();
      }));
    }
    return requests.get(handle);
  }

  function pump() {
    while (active < 4 && queue.length) {
      (function (job) {
        active += 1;
        var controller = new AbortController();
        var timeout = setTimeout(function () { controller.abort(); }, 15000);
        fetch(config.root.replace(/\/?$/, '/') + 'products/' + encodeURIComponent(job.handle) + '.js', {
          credentials: 'same-origin', signal: controller.signal
        }).then(function (response) {
          if (!response.ok) throw new Error('Product price unavailable');
          return response.json();
        }).then(function (product) {
          var variants = product.variants || [];
          var variant = variants.find(function (item) { return item.available; }) || variants[0];
          if (!variant || !Number.isFinite(variant.price)) throw new Error('Product price unavailable');
          job.resolve(variant);
        }).catch(job.reject).finally(function () {
          clearTimeout(timeout);
          active -= 1;
          pump();
        });
      })(queue.shift());
    }
  }

  function span(className, text) {
    var node = document.createElement('span');
    node.className = className;
    node.textContent = text;
    return node;
  }

  function money(cents) {
    // Shopify's format matches the product page, including EUR separators.
    var node = document.createElement('span');
    node.innerHTML = Currency.formatMoney(cents, config.moneyFormat);
    return node.textContent;
  }

  function hydrate(card) {
    if (seen.has(card)) return;
    seen.add(card);
    var link = card.querySelector('a[href*="/products/"]');
    var pricing = card.querySelector('.modern-product-pricing');
    if (!link || !pricing) return;
    var match = new URL(link.href, location.origin).pathname.match(/\/products\/([^/]+)/);
    if (!match) return;
    var badge = card.querySelector('.badge-sale');
    if (badge) badge.hidden = true;
    pricing.textContent = 'Loading price…';
    pricing.setAttribute('aria-busy', 'true');
    // Strict results are already present. Do not keep them hidden while an
    // unrelated deferred script delays DOMContentLoaded.
    var pendingStyle = document.getElementById('ts-vl-strict-pending-inline');
    if (pendingStyle) pendingStyle.remove();
    productPrice(decodeURIComponent(match[1])).then(function (variant) {
      var sale = variant.compare_at_price > variant.price;
      var content = document.createDocumentFragment();
      if (sale) {
        var row = document.createElement('div');
        row.className = 'modern-price-row';
        row.appendChild(span('modern-price-old', money(variant.compare_at_price)));
        row.appendChild(span('modern-price-new', money(variant.price)));
        content.appendChild(row);
        content.appendChild(span('modern-price-savings', 'Save ' + Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price) + '%'));
      } else {
        content.appendChild(span('modern-price-new modern-price-regular', money(variant.price)));
      }
      pricing.replaceChildren(content);
      pricing.dataset.currency = config.currency;
      if (badge) badge.hidden = !sale;
    }).catch(function () {
      var view = document.createElement('a');
      view.href = link.href;
      view.textContent = 'View price';
      pricing.replaceChildren(view);
    }).finally(function () {
      pricing.removeAttribute('aria-busy');
    });
  }

  function scan(node) {
    if (node.nodeType !== 1) return;
    if (node.matches(selector)) hydrate(node);
    node.querySelectorAll(selector).forEach(hydrate);
  }
  document.querySelectorAll(selector).forEach(hydrate);
  new MutationObserver(function (mutations) {
    mutations.forEach(function (mutation) { mutation.addedNodes.forEach(scan); });
  }).observe(document.body, { childList: true, subtree: true });
})();
